"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareIconButton = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _utils = require("../../utils");
const ShareIconButton = exports.ShareIconButton = (0, _mui.styled)(_components.IconButton, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['desktopSize'])
})(({
  desktopSize,
  theme
}) => ({
  [theme.breakpoints.up('sm')]: {
    ...(0, _utils.getDesktopSize)(desktopSize)
  }
}));
